import { IProject } from "./interfaces";

export const projects: IProject[] = [
  {
    name: "Plate Atlas",
    description:
      "Reference for international vehicle registration codes and license plate examples.",
    date: "2025 - 2026",
    mainColor: "#9d80d1",
    backgroundImage: "plate-atlas-bg.webp",
    githubLink: "https://github.com/timii/plate-atlas",
    websiteLink: "https://timii.github.io/plate-atlas/overview",
    buttonText: "Live Demo",
    tags: ["Typescript", "Vue", "License Plates"],
  },
  {
    name: "voidcut",
    description:
      "Non-linear video editor designed to run entirely in the web browser.",
    date: "2023 - 2025",
    mainColor: "#0284c7",
    backgroundImage: "voidcut-bg.webp",
    githubLink: "https://github.com/timii/voidcut",
    websiteLink: "https://timii.github.io/voidcut/",
    buttonText: "Live Demo",
    tags: ["Typescript", "Svelte", "Video Editor", "FFMPEG"],
  },
  {
    name: "Pathfinder",
    description: "A website to visualize pathfinding algorithms",
    date: "2023",
    mainColor: "#379237",
    backgroundImage: "pathfinder-bg.webp",
    githubLink: "https://github.com/timii/pathfinder",
    websiteLink: "https://timii.github.io/pathfinder/",
    buttonText: "Live Demo",
    tags: ["Typescript", "Svelte", "Pathfinding Algorithms"],
  },
  {
    name: "Sorting Visualizer",
    description: "A website to visualize sorting algorithms",
    date: "2022 - 2023",
    mainColor: "#dd6718",
    backgroundImage: "sorting-visualizer-bg.webp",
    githubLink: "https://github.com/timii/sorting-visualizer",
    websiteLink: "https://timii.github.io/sorting-visualizer/",
    buttonText: "Live Demo",
    tags: ["Typescript", "Vue", "Sorting Algorithms"],
  },
  {
    name: "Word Ocean",
    description:
      "A website to lookup word definitions and additional information",
    date: "2021 - 2022",
    mainColor: "#cf4725",
    backgroundImage: "wordocean-bg.webp",
    githubLink: "https://github.com/timii/WordOcean",
    websiteLink: "https://timii.github.io/WordOcean",
    buttonText: "Live Demo",
    tags: ["JavaScript", "React", "Dictionary"],
  },
  {
    name: "Snapper",
    description:
      "An easy-to-use chrome extension for taking screenshots in your browser",
    date: "2021 - 2022",
    mainColor: "#30a9de",
    backgroundImage: "snapper-bg.webp",
    githubLink: "https://github.com/timii/Snapper",
    websiteLink:
      "https://chrome.google.com/webstore/detail/snapper/opchjelombkjeoleoaganhaofjgjnbod",
    buttonText: "Chrome Store",
    tags: ["JavaScript", "Extension"],
  },
  {
    name: "Memory Game",
    description:
      "A simple game to train your memory and have fun while doing so",
    date: "2021",
    mainColor: "#FF2E2E",
    backgroundImage: "memory-bg.webp",
    githubLink: "https://github.com/sentouki/Memory-Game",
    websiteLink: "https://sentouki.github.io/Memory-Game",
    buttonText: "Live Demo",
    tags: ["JavaScript", "p5.js", "Game"],
  },
  {
    name: "MadMaths",
    description:
      "A maths learning program to help you improve your maths skills",
    date: "2019",
    mainColor: "#d18700",
    buttonBackgroundColor: "#ff5700",
    backgroundImage: "madmaths-bg.webp",
    githubLink: "https://github.com/timii/MadMaths",
    tags: ["C#", "WPF", "Maths"],
  },
  {
    name: "Pong",
    description: "A small Pong clone made in Unity",
    date: "2020",
    mainColor: "#243740",
    buttonBackgroundColor: "#fff",
    buttonTextColor: "#243740",
    backgroundImage: "pong-bg.webp",
    githubLink: "https://github.com/timii/Pong",
    tags: ["C#", "Unity", "Game"],
  },
  {
    name: "Habits",
    description: "A mobile app to help you improve and form good new habits",
    date: "2020",
    mainColor: "#2e7330",
    backgroundImage: "habits-bg.webp",
    githubLink: "https://github.com/timii/Habits",
    tags: ["Kotlin", "Mobile"],
  },
  {
    name: "Kalorientracker",
    description:
      "A voice assistant app to help you track and calculate your daily calories",
    date: "2019",
    mainColor: "#2eb0d1",
    backgroundImage: "kalorientracker-bg.webp",
    githubLink: "https://github.com/timii/Kalorientracker",
    tags: ["JavaScript", "Voice Assistant"],
  },
];
